import { useRef, useEffect, useState, type FunctionComponent, } from "react"
import { createPortal, } from "react-dom";
import { useModalizeStore,  } from "./ModalizeStore";

import type { ModalizeProps, ModalProps, } from "./types";
import "./Modalize.scss";
import { CrossThin, } from "@icons";

export declare type ModalizeMainProps = {

	/** DOM selector which will act as a parent for this Modalize */
	parent?: string;

};


export const Modalize: FunctionComponent<ModalizeMainProps> = ({
	parent = "body",
}) => {

	const {
		banner,
		blur,
		buttons,
		classes,
		props,
		subtitle,
		title,
		Component,
		onBack,
		onClose,
	} = useModalizeStore();

	const modalId = "modalize-overlay"
	const modalSelector = `#${modalId}`

	const [ rootReady, setRootReady ] = useState(false);

	useEffect(() => {
		const parentNode = document.querySelector(parent);
		if( parentNode ) {
			const node = document.createElement('div');
			const exists = parentNode.querySelector(modalSelector);
			node.id = modalId;
			if( !exists ) {
				parentNode.appendChild(node);
			}
			setRootReady(true);
		}
	}, []);

	return <>{
		rootReady &&
		Component &&
		<Modal {
			...{
				Component,
				props,
				title,
				subtitle,
				parent: modalSelector,
				classes,
				buttons,
				banner,
				blur,
				onBack,
				onClose,
			} }
		/>
	}</>;

}


export const Modal = ({
	Component,
	props,
	classes,
	closeable = true,
	parent = "#modalize-overlay",
	title,
	subtitle,
	buttons = [],
	banner = true,
	blur = true,
	onBack,
	onClose = ( ) => { },
}: ModalProps & { parent?: string; }) => {

	const classNames = [
		`modalize-modal`,
		classes ? classes.split(" ") : null,
		blur ? "blur" : null,
	].filter(v => v).join(" ");

	const { dismiss, } = useModalizeStore();
	const onCloseModal = ( ) => {
		onClose();
		dismiss();
	}
	const parentNode = document.querySelector(parent);
	if( parentNode ) {
		return createPortal(
			<div className={classNames}>
				{ banner && (
					<div className="banner">
						<div className="titles">
							<h5>{title}</h5>
							{ subtitle && <p className="subtitle">{subtitle}</p> }
						</div>
						{ onBack && <div className="btn back" onClick={onBack}>back</div> }
						{ closeable && <div className="btn close" onClick={onCloseModal}><CrossThin /></div> }
					</div>
				) }
				<div className="panel">
					<Component {...props} />
				</div>
				{
					buttons.length ? (
						<div className="buttons">
						{
							buttons.map(({button: Button, buttonProps}, idx) => <Button key={idx} {...buttonProps || {}} /> )
						}
						</div>
					) : null
				}
				</div>,
			parentNode
		);
	}
	throw new Error("Modal:: parent not ready");
}
